"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sites = void 0;
const sdk_1 = require("../sdk");
var Sites;
(function (Sites) {
    Sites.list = (options) => {
        const url = '/sites';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Sites.get = (siteId) => {
        const url = `/sites/${siteId}`;
        return sdk_1.SDK.axios.get(url);
    };
})(Sites = exports.Sites || (exports.Sites = {}));
//# sourceMappingURL=sites.js.map